<template>
<section class="px-4 py-5 mx-auto max-w-5xl bg-white 2xl:px-0 lg:pb-10">
    <div class="mx-auto">
        <!-- Main Heading -->
        <div class="mb-4 text-2xl text-center sm:text-3xl md:text-32 font-ww-bold" v-html="mainHeading">
        </div>
        
        <!-- Intro Text -->
        <div class="mx-auto mt-5 mb-5 text-sm text-left lg:text-lg md:text-base md:mt-10 md:mb-10" v-html="introText">
        </div>

        <ul class="ml-6 space-y-2 text-sm list-disc md:text-base md:space-y-4 md:ml-20 lg:text-lg">
            <li v-for="(item, index) in listItems" :key="index" v-html="item.text">
            </li>
        </ul>
        
        <!-- Highlighted Box -->
        <div class="flex items-center px-6 py-4 mt-8 space-x-4 border" :style="{ backgroundColor: highlightBoxBgColor, borderColor: highlightBoxBorderColor }">
            <!-- Lightbulb Icon -->
            <div class="flex-shrink-0" v-if="showIcon">
                <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.9149 9.98958C14.069 10.8863 10.9731 13.9362 10.0277 17.7596C9.07933 21.5953 10.1647 25.505 12.9312 28.2179C13.9098 29.1777 14.4941 30.7159 14.4941 32.3327V32.5908C14.4941 33.6555 14.9587 34.6136 15.6953 35.2738V37.3955C15.6953 39.3825 17.3118 40.999 19.2988 40.999H21.7012C23.6881 40.999 25.3047 39.3825 25.3047 37.3955V35.2738C26.0413 34.6136 26.5058 33.6556 26.5058 32.5908V32.328C26.5058 30.7357 27.1214 29.1683 28.1525 28.135C30.189 26.0941 31.3105 23.3822 31.3105 20.499C31.3105 13.606 24.9228 8.35614 17.9149 9.98958ZM22.9023 37.3955C22.9023 38.0578 22.3635 38.5967 21.7012 38.5967H19.2988C18.6365 38.5967 18.0976 38.0578 18.0976 37.3955V36.1943H22.9023V37.3955ZM26.4519 26.4381C24.9595 27.9337 24.1035 30.0805 24.1035 32.328V32.5908C24.1035 33.2531 23.5647 33.792 22.9023 33.792H18.0976C17.4353 33.792 16.8965 33.2531 16.8965 32.5908V32.3327C16.8965 30.0506 16.0642 27.9256 14.6132 26.5027C12.4599 24.3911 11.6176 21.3382 12.3597 18.3363C13.0904 15.3808 15.4851 13.0229 18.4604 12.3292C23.9595 11.0469 28.9082 15.1521 28.9082 20.499C28.9082 22.7415 28.0358 24.8507 26.4519 26.4381Z" fill="black"/>
<path d="M11.157 9.4582L7.75951 6.06081C7.29049 5.59171 6.52991 5.59171 6.06081 6.06081C5.59171 6.52991 5.59171 7.29041 6.06081 7.7595L9.45828 11.1569C9.9273 11.626 10.688 11.626 11.157 11.1569C11.6261 10.6878 11.6261 9.9273 11.157 9.4582Z" fill="black"/>
<path d="M6.08594 19.2988H1.20117C0.537805 19.2988 0 19.8366 0 20.5C0 21.1634 0.537805 21.7012 1.20117 21.7012H6.08594C6.7493 21.7012 7.28711 21.1634 7.28711 20.5C7.28711 19.8366 6.7493 19.2988 6.08594 19.2988Z" fill="black"/>
<path d="M39.7988 19.2988H34.9141C34.2507 19.2988 33.7129 19.8366 33.7129 20.5C33.7129 21.1634 34.2507 21.7012 34.9141 21.7012H39.7988C40.4622 21.7012 41 21.1634 41 20.5C41 19.8366 40.4622 19.2988 39.7988 19.2988Z" fill="black"/>
<path d="M34.9382 6.06081C34.4693 5.59171 33.7087 5.59171 33.2395 6.06081L29.8421 9.4582C29.373 9.92722 29.373 10.6878 29.8421 11.1569C30.3111 11.626 31.0717 11.626 31.5408 11.1569L34.9382 7.7595C35.4073 7.29049 35.4073 6.52991 34.9382 6.06081Z" fill="black"/>
<path d="M20.5 0C19.8366 0 19.2988 0.537805 19.2988 1.20117V6.08594C19.2988 6.7493 19.8366 7.28711 20.5 7.28711C21.1634 7.28711 21.7012 6.7493 21.7012 6.08594V1.20117C21.7012 0.537805 21.1634 0 20.5 0Z" fill="black"/>
<path d="M20.5005 14.4941C20.0067 14.4941 19.5037 14.5533 19.0064 14.6698C16.9352 15.1533 15.2012 16.8582 14.6919 18.9123C14.5322 19.5562 14.9246 20.2076 15.5685 20.3673C16.2125 20.527 16.8638 20.1344 17.0235 19.4906C17.3167 18.3088 18.3565 17.2885 19.5534 17.0091C19.8723 16.9344 20.191 16.8965 20.5005 16.8965C21.1638 16.8965 21.7016 16.3587 21.7016 15.6953C21.7016 15.0319 21.1638 14.4941 20.5005 14.4941Z" fill="black"/>
</svg>
            </div>
            <div class="text-sm italic lg:text-17 md:text-base" v-html="highlightBoxText">
            </div>
        </div>
    </div>
</section>
</template>

<script setup>
defineProps({
  mainHeading: {
    type: String,
    default: 'Who is Mindflow for?'
  },
  introText: {
    type: String,
    default: 'If you rely on your brain to perform at its best—Mindflow was made for you.'
  },
  listItems: {
    type: Array,
    default: () => [
      {
        text: '<strong>Entrepreneurs, creatives, and high performers</strong> who need mental stamina for deep work and decision'
      },
      {
        text: '<strong>Students</strong> who want to study smarter and stay sharp without burning out'
      },
      {
        text: '<strong>Moms and dads</strong> balancing endless tasks and needing energy without anxiety'
      },
      {
        text: '<strong>Professionals and knowledge workers</strong> seeking clear-headed, focused productivity all day'
      },
      {
        text: '<strong>Health-conscious coffee lovers</strong> who want cleaner, more effective energy without crashing'
      },
      {
        text: '<strong>Anyone who wants to feel mentally</strong> "on" without pills, sugar, or synthetic hacks'
      }
    ]
  },
  showIcon: {
    type: Boolean,
    default: true
  },
  highlightBoxText: {
    type: String,
    default: 'Mindflow helps people who want more out of life—without feeling overstimulated or burned out in the process.'
  },
  highlightBoxBgColor: {
    type: String,
    default: '#F1FBC8'
  },
  highlightBoxBorderColor: {
    type: String,
    default: '#C4E538'
  }
})

defineBuilderComponent({
    friendlyName: 'Title Points Info Box',
    canHaveChildren: false,
    inputs: [
        {
            name: 'mainHeading',
            type: 'richText',
            defaultValue: 'Who is Mindflow for?'
        },
        {
            name: 'introText',
            type: 'richText',
            defaultValue: 'If you rely on your brain to perform at its best—Mindflow was made for you.'
        },
        {
            name: 'listItems',
            type: 'list',
            subFields: [
                {
                    name: 'text',
                    type: 'richText',
                    defaultValue: ''
                }
            ],
            defaultValue: [
                {
                    text: '<strong>Entrepreneurs, creatives, and high performers</strong> who need mental stamina for deep work and decision'
                },
                {
                    text: '<strong>Students</strong> who want to study smarter and stay sharp without burning out'
                },
                {
                    text: '<strong>Moms and dads</strong> balancing endless tasks and needing energy without anxiety'
                },
                {
                    text: '<strong>Professionals and knowledge workers</strong> seeking clear-headed, focused productivity all day'
                },
                {
                    text: '<strong>Health-conscious coffee lovers</strong> who want cleaner, more effective energy without crashing'
                },
                {
                    text: '<strong>Anyone who wants to feel mentally</strong> "on" without pills, sugar, or synthetic hacks'
                }
            ]
        },
        {
            name: 'showIcon',
            type: 'boolean',
            defaultValue: true
        },
        {
            name: 'highlightBoxText',
            type: 'richText',
            defaultValue: 'Mindflow helps people who want more out of life—without feeling overstimulated or burned out in the process.'
        },
        {
            name: 'highlightBoxBgColor',
            type: 'color',
            defaultValue: '#F1FBC8'
        },
        {
            name: 'highlightBoxBorderColor',
            type: 'color',
            defaultValue: '#C4E538'
        }
    ]
})
</script>

<style scoped>
</style>